import React, { Component } from 'react';
import { Card, CardBody,
     Col, CardHeader, Badge, Row } from 'reactstrap';

import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import NameComponent from './NameComponent';
import SearchingTitleComponent from './SearchingTitleComponent';
import { GetListAttempt_ACTION } from '../Actions/LogisticActions';

class LODComponent extends Component {

   constructor(props){
       super(props)

       this.state = {

       }

       this.renderLOD = this.renderLOD.bind(this)
   }

   componentDidMount(){
   }

  render() {
    return (
      <div className="animated fadeIn" style = {{overflowY:'scroll', height:this.props.Height || 120}} >
          {(this.props.IsSearching || this.props.IsSearching == undefined || this.props.GetError)  ? 
          <SearchingTitleComponent error = {this.props.GetError} onError = {() => this.props.GetLODs()}/>
               :<div style = {{flexDirection:'column', display:'flex'}}>
                 {[{Name:'All', HexColor:'white', Id:-1}, ...this.props.LODs].map((l, i) => this.renderLOD(l, i))}
                 </div>}
      </div>
    )
  }

  renderLOD(LOD, i){
    return(
      <div 
      style = {{border: 1.8 , borderStyle:'dashed', borderColor:this.state.SelectedIndex == i ? 'green' : '#cccccc', marginBottom:20, cursor:'pointer'}}
      onClick = {() => {
        this.setState({SelectedIndex:i})
        this.props.Object.setState({SelectedLODId:LOD.Id, SelectedLOD:i, Recalculate: true})
      }}
      key = {i}
       >
        <div style = {{flexDirection:'column', display:'flex', height:40,width:100, margin:3, alignContent:'center', alignItems:'center'}}>
          <NameComponent text = {LOD.Name} textColor = "black"/>
          <div  style = {{width:'100%', height:20, backgroundColor:LOD.HexColor, borderTop:1, borderTopColor:'gray', borderTopStyle:'solid'}}/>
        </div>
      </div>
    )
  }
}

//Constant
const LOD_SEARCHING_PARAMETER = 'IsLODSearching'

const LOD_DATA_PARAMETER = 'LODs'

const LOD_GET_ERROR_PARAMETER = 'LODsGetError'
function MapStateToProps(state) {
    return {
      LODs:state.Query[LOD_DATA_PARAMETER],

      IsSearching: state.Query[LOD_SEARCHING_PARAMETER],

      GetError: state.Query[LOD_GET_ERROR_PARAMETER],
      }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
      GetLODs: () => {dispatch(GetListAttempt_ACTION({
        SearchParameter: LOD_SEARCHING_PARAMETER,
        DataParameter: LOD_DATA_PARAMETER,
        GetErrorParameter: LOD_GET_ERROR_PARAMETER,
        Path: Routes.GetLevelsOfDifficulty,

        [LOD_SEARCHING_PARAMETER]: true,
        
        [LOD_DATA_PARAMETER]: [],

        [LOD_GET_ERROR_PARAMETER]: '',
    }))},
    }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(LODComponent)

